import {all, call, fork, put, takeEvery, putResolve} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import CompanyActions from '../Company/actions';
import {get, patch, post, puto} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";
import ListActions from "../List/actions";
import {L} from "../List/reducer";
import { store } from '../store';

// Read settings
export function* readSettingsRequest() {
    yield takeEvery(actions.SETTING_READ_ALL_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/settings', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.SETTING_READ_ALL_SUCCESS,
                settings: data.settings,
            });
        }
        catch (error) {
            yield put({
                type: actions.SETTING_READ_ALL_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readSettingsSuccess() {
    yield takeEvery(actions.SETTING_READ_ALL_SUCCESS, () => {});
}
export function* readSettingsError() {
    yield takeEvery(actions.SETTING_READ_ALL_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update settings
export function* updateSettingsRequest() {
    yield takeEvery(actions.SETTING_UPDATE_MULTIPLE_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            context.allow_intercept = true;
            const response = yield call(patch, '/settings', request, context);
            const data = yield response.data;
            yield putResolve({
                type: ListActions.LIST_READ_LISTS_SUCCESS,
                responseData: {
                    settings: {
                        items: data.settings,
                        version: null,
                    },
                },
                lists: [L.settings],
                params: {},
                requesterIds: [],
                showSpinner: false,
            });

            // OK
            yield put({
                type: actions.SETTING_UPDATE_MULTIPLE_SUCCESS,
                settings: data.settings,
            });

            const { Auth } = store.getState();
            if (Auth.companyCountryCode === 'MY') {
                const myInvoisReadyResponse = yield call(get, '/companies/current/profile/is_myinvois_ready', null, context);
                const myInvoisReadyData = yield myInvoisReadyResponse.data;

                yield put({
                    type: CompanyActions.SET_PREV_AND_CURRENT_IS_MY_INVOIS_READY,
                    prevIsMyInvoisReady: myInvoisReadyData.is_myinvois_ready,
                    isMyInvoisReady: null,
                });
            }
        }
        catch (error) {
            yield put({
                type: actions.SETTING_UPDATE_MULTIPLE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateSettingsSuccess() {
    yield takeEvery(actions.SETTING_UPDATE_MULTIPLE_SUCCESS, function* () {
        yield message.success(t`The settings are updated.`);
    });
}
export function* updateSettingsError() {
    yield takeEvery(actions.SETTING_UPDATE_MULTIPLE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update API settings
export function* updateApiSettingsRequest() {
    yield takeEvery(actions.SETTING_UPDATE_API_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(puto, '/settings/api', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.SETTING_UPDATE_API_SUCCESS,
                settings: data.settings,
            });
        }
        catch (error) {
            yield put({
                type: actions.SETTING_UPDATE_API_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateApiSettingsSuccess() {
    yield takeEvery(actions.SETTING_UPDATE_API_SUCCESS, function* () {
        yield message.success(t`API access settings are updated.`);
    });
}
export function* updateApiSettingsError() {
    yield takeEvery(actions.SETTING_UPDATE_API_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Refresh API token
export function* refreshApiTokenRequest() {
    yield takeEvery(actions.REFRESH_API_TOKEN_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/settings/api/refresh', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.REFRESH_API_TOKEN_SUCCESS,
                settings: data.settings,
            });
        }
        catch (error) {
            yield put({
                type: actions.REFRESH_API_TOKEN_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* refreshApiTokenSuccess() {
    yield takeEvery(actions.REFRESH_API_TOKEN_SUCCESS, function* () {
        yield message.success(t`API access token refreshed.`);
    });
}
export function* refreshApiTokenError() {
    yield takeEvery(actions.REFRESH_API_TOKEN_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read all shoebox contacts
export function* readAllShoeboxContactsRequest() {
    yield takeEvery(actions.SETTING_READ_ALL_SHOEBOX_CONTACTS_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/settings/shoebox', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.SETTING_READ_ALL_SHOEBOX_CONTACTS_SUCCESS,
                contacts: data.contacts,
                pagination: data.pagination,
            });
        }
        catch (error) {
            yield put({
                type: actions.SETTING_READ_ALL_SHOEBOX_CONTACTS_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readAllShoeboxContactsSuccess() {
    yield takeEvery(actions.SETTING_READ_ALL_SHOEBOX_CONTACTS_SUCCESS, () => {});
}
export function* readAllShoeboxContactsError() {
    yield takeEvery(actions.SETTING_READ_ALL_SHOEBOX_CONTACTS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update shoebox email
export function* updateShoeboxEmailRequest() {
    yield takeEvery(actions.SETTING_UPDATE_SHOEBOX_EMAIL_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(puto, `/settings/shoebox/${id}/email`, null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.SETTING_UPDATE_SHOEBOX_EMAIL_SUCCESS,
                email: data.email,
            });
        }
        catch (error) {
            yield put({
                type: actions.SETTING_UPDATE_SHOEBOX_EMAIL_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateShoeboxEmailSuccess() {
    yield takeEvery(actions.SETTING_UPDATE_SHOEBOX_EMAIL_SUCCESS, function* () {
        yield message.success(t`The shoebox email address is updated.`);
    });
}
export function* updateShoeboxEmailError() {
    yield takeEvery(actions.SETTING_UPDATE_SHOEBOX_EMAIL_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update shoebox number
export function* updateShoeboxNumberRequest() {
    yield takeEvery(actions.SETTING_UPDATE_SHOEBOX_NUMBER_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(puto, `/settings/shoebox/${id}/number`, request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.SETTING_UPDATE_SHOEBOX_NUMBER_SUCCESS,
                number: data.number,
            });
        }
        catch (error) {
            yield put({
                type: actions.SETTING_UPDATE_SHOEBOX_NUMBER_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateShoeboxNumberSuccess() {
    yield takeEvery(actions.SETTING_UPDATE_SHOEBOX_NUMBER_SUCCESS, function* () {
        yield message.success(t`The shoebox number is updated.`);
    });
}
export function* updateShoeboxNumberError() {
    yield takeEvery(actions.SETTING_UPDATE_SHOEBOX_NUMBER_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}
// Read numbers
export function* readNumbersRequest() {
    yield takeEvery(actions.SETTING_NUMBER_READ_ALL_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/settings/transaction_numbers', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.SETTING_NUMBER_READ_ALL_SUCCESS,
                transactionNumbers: data.transaction_numbers,
                customTransactionNumberOn: data.setting.data,
            });
        }
        catch (error) {
            yield put({
                type: actions.SETTING_NUMBER_READ_ALL_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readNumbersSuccess() {
    yield takeEvery(actions.SETTING_NUMBER_READ_ALL_SUCCESS, () => {});
}
export function* readNumbersError() {
    yield takeEvery(actions.SETTING_NUMBER_READ_ALL_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update numbers
export function* updateNumbersRequest() {
    yield takeEvery(actions.SETTING_NUMBER_UPDATE_ALL_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(puto, '/settings/transaction_numbers', request, context);

            // OK
            yield put({
                type: actions.SETTING_NUMBER_UPDATE_ALL_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.SETTING_NUMBER_UPDATE_ALL_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateNumbersSuccess() {
    yield takeEvery(actions.SETTING_NUMBER_UPDATE_ALL_SUCCESS, function* () {
        yield message.success(t`Company settings are updated.`);
    });
}
export function* updateNumbersError() {
    yield takeEvery(actions.SETTING_NUMBER_UPDATE_ALL_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(readSettingsRequest),
        fork(readSettingsSuccess),
        fork(readSettingsError),
        fork(updateSettingsRequest),
        fork(updateSettingsSuccess),
        fork(updateSettingsError),
        fork(updateApiSettingsRequest),
        fork(updateApiSettingsSuccess),
        fork(updateApiSettingsError),
        fork(refreshApiTokenRequest),
        fork(refreshApiTokenSuccess),
        fork(refreshApiTokenError),
        fork(readAllShoeboxContactsRequest),
        fork(readAllShoeboxContactsSuccess),
        fork(readAllShoeboxContactsError),
        fork(updateShoeboxEmailRequest),
        fork(updateShoeboxEmailSuccess),
        fork(updateShoeboxEmailError),
        fork(updateShoeboxNumberRequest),
        fork(updateShoeboxNumberSuccess),
        fork(updateShoeboxNumberError),
        fork(readNumbersRequest),
        fork(readNumbersSuccess),
        fork(readNumbersError),
        fork(updateNumbersRequest),
        fork(updateNumbersSuccess),
        fork(updateNumbersError),
    ]);
}
